import { render, staticRenderFns } from "./alerts-detail.vue?vue&type=template&id=6f6fc345&"
import script from "./alerts-detail.vue?vue&type=script&lang=js&"
export * from "./alerts-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports